import { render, staticRenderFns } from "./financialAsset.vue?vue&type=template&id=323f9dc0&scoped=true"
import script from "./financialAsset.vue?vue&type=script&lang=js"
export * from "./financialAsset.vue?vue&type=script&lang=js"
import style0 from "./financialAsset.vue?vue&type=style&index=0&id=323f9dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f9dc0",
  null
  
)

export default component.exports